import {createRouter, createWebHashHistory} from "vue-router";
import HomePage from "@/views/HomePage.vue"
import LoginPage from "@/views/LoginPage.vue"
import RegisterPage from "@/views/RegisterPage";
import UserInfoHome from "@/views/userInfo/UserInfoHome";
import OrderList from "@/views/userInfo/OrderList";
import mediumFireDeviceHome from "@/views/fire/MediumFireDeviceHome";
import theoryMediumDevicePracticeTry from "@/views/fire/try/practice/TheoryMediumDevice";
import theoryPaperPractice from "@/views/fire/TheoryPaperPractice";
import theoryMediumDeviceExamTry from "@/views/fire/try/exam/TheoryMediumDevice";
import theoryMediumDevicePracticeNormal from "@/views/fire/normal/practice/TheoryMediumDevice";
import theoryMediumDeviceExamNormal from "@/views/fire/normal/exam/TheoryMediumDevice";
import theoryPaperExam from "@/views/fire/TheoryPaperExam";
import testPage from "@/views/fire/TestPage";
import examScore from "@/views/fire/ExamScore";
import peopleMediumDevicePracticeNormal from "@/views/fire/normal/practice/PeopleMediumDevice";
import peoplePaperPractice from "@/views/fire/PeoplePaperPractice";
import peopleMediumDeviceExamNormal from "@/views/fire/normal/exam/PeopleMediumDevice";
import peoplePaperExam from "@/views/fire/PeoplePaperExam"
import examHistory from "@/views/userInfo/examHistory"
import legalAgree from "@/views/LegalAgree"
import buyPage from "@/views/BuyPage"
import peopleMediumDevicePracticeTry from "@/views/fire/try/practice/PeopleMediumDevice";
import peopleMediumDeviceExamTry from "@/views/fire/try/exam/PeopleMediumDevice";
import pointCardExchange from "@/views/userInfo/PointCardExchange";
import pointCardTask from "@/components/PointCardTask";
import testPaging from "@/views/TestPaging";
import pageContentInfo from "@/views/pages/news/PageContentInfo";

import {ref} from "vue";


const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        meta: {title: '首页'}
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {title: '登录'}
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterPage,
        meta: {title: '注册'}
    },
    {
        path: '/userInfo/userInfoHome',
        name: 'userInfoHome',
        component: UserInfoHome,
        meta: {title: '个人中心'}
    },
    {
        path: '/userInfo/orderList',
        name: 'orderList',
        component: OrderList,
        meta: {title: '订单'}
    },
    {
        path: '/userInfo/examHistory',
        name: 'examHistory',
        component: examHistory,
        meta: {title: '考试历史信息'}
    },
    {
        path: '/fire/MediumFireDeviceHome',
        name: 'mediumFireDeviceHome',
        component: mediumFireDeviceHome,
        meta: {title: '中级消防设施操作员模拟系统'}
    },
    {
        path: '/fire/try/practice/theoryMediumDevice',
        name: 'theoryMediumDevicePractice',
        component: theoryMediumDevicePracticeTry,
        meta: {title: '中级消防设施操作员-理论题练习试用'}
    },
    {
        path: '/fire/theoryPaperPractice',
        name: 'theoryPaperPractice',
        component: theoryPaperPractice,
        meta: {title: '中级消防设施操作员-理论题'}
    },
    {
        path: '/fire/try/exam/TheoryMediumDevice',
        name: 'theoryMediumDeviceExam',
        component: theoryMediumDeviceExamTry,
        meta: {title: '中级消防设施操作员-理论题考试试用'}
    },
    {
        path: '/fire/theoryPaperExam',
        name: 'theoryPaperExam',
        component: theoryPaperExam,
        meta: {title: '中级消防设施操作员-理论题'}
    },
    {
        path: '/fire/ExamScore',
        name: 'examScore',
        component: examScore,
        meta: {title: '考试得分'}
    },
    {
        path: '/fire/normal/practice/theoryMediumDevice',
        name: 'theoryMediumDevicePracticeNormal',
        component: theoryMediumDevicePracticeNormal,
        meta: {title: '中级消防设施操作员-理论题练习'}
    },
    {
        path: '/fire/normal/exam/TheoryMediumDevice',
        name: 'theoryMediumDeviceExamNormal',
        component: theoryMediumDeviceExamNormal,
        meta: {title: '中级消防设施操作员-理论题考试'}
    },
    {
        path: '/fire/normal/practice/peopleMediumDevice',
        name: 'peopleMediumDevicePracticeNormal',
        component: peopleMediumDevicePracticeNormal,
        meta: {title: '中级消防设施操作员-操作题练习'}
    },
    {
        path: '/fire/peoplePaperPractice',
        name: 'peoplePaperPractice',
        component: peoplePaperPractice,
        meta: {title: '中级消防设施操作员-操作题练习'}
    },
    {
        path: '/fire/testPage',
        name: 'testPage',
        component: testPage,
        meta: {title: '测试'}
    },
    {
        path: '/fire/normal/exam/peopleMediumDevice',
        name: 'peopleMediumDeviceExamNormal',
        component: peopleMediumDeviceExamNormal,
        meta: {title: '中级消防设施操作员-操作题考试'}
    },
    {
        path: '/fire/peoplePaperExam',
        name: 'peoplePaperExam',
        component: peoplePaperExam,
        meta: {title: '中级消防设施操作员-操作题'}
    },
    {
        path: '/legalAgree',
        name: 'legalAgree',
        component: legalAgree,
        meta: {title: '平台协议'}
    }, {
        path: '/buyPage',
        name: 'buyPage',
        component: buyPage,
        meta: {title: '购买页面'}
    },
    {
        path: '/fire/try/practice/PeopleMediumDevice',
        name: 'peopleMediumDevicePracticeTry',
        component: peopleMediumDevicePracticeTry,
        meta: {title: '中级消防设施操作员-操作题练习试用'}
    },
    {
        path: '/fire/try/exam/PeopleMediumDevice',
        name: 'peopleMediumDeviceExamTry',
        component: peopleMediumDeviceExamTry,
        meta: {title: '中级消防设施操作员-操作题考试试用'}
    },
    {
        path: '/userInfo/PointCardExchange',
        name: 'PointCardExchange',
        component: pointCardExchange,
        meta: {title: '积分兑换'}
    },
    {
        path: '/components/PointCardTask',
        name: 'PointCardTask',
        component: pointCardTask,
        meta: {title: '获取积分'}
    },
    {
        path: '/TestPaging',
        name: 'TestPaging',
        component: testPaging,
        meta: {title: '测试分页'}
    },
    {
        path: '/pages/news/PageContentInfo',
        name: 'PageContentInfo',
        component: pageContentInfo,
        meta: {title: '内容'}
    }
]

const router = createRouter({
        history: createWebHashHistory(),
        routes
    }
)


router.beforeEach((to, from, next) => {
    //验证token,只有存在token的时候，才能跳转到内容页
    // console.log(to);
    // console.log(from);
    let token = localStorage.getItem("userToken");
    const nextPath = ref(['/login', '/register', '/', '/fire/mediumFireDeviceHome', '/fire/try/practice/TheoryMediumDevice', '/fire/try/practice/PeopleMediumDevice', '/legalAgree'])
    if (token || nextPath.value.indexOf(to.path) !== -1 || from.fullPath !== to.fullPath) {
        next();
        // console.log(token);
    } else {
        next("/login");
    }
})

export default router

